$(function(){
	$('#tk_contact_submit').click(function(){
		if(!input_check()){
			return false;
		}
	});
});

// 入力内容チェックのための関数
function input_check(){
	var result = true;

	// エラー用装飾のためのクラスリセット
	$('.tk_name').removeClass("inp_error");
	$('.tk_email').removeClass("inp_error");
	$('.tk_tel').removeClass("inp_error");
	$('.tk_contact').removeClass("inp_error");

	// 入力エラー文をリセット
	$("#tk_name_error").empty();
	$("#tk_email_error").empty();
	$("#tk_tel_error").empty();
	$("#tk_contact_error").empty();

	// 入力内容セット
	var tkName = $(".tk_name").val();
	var tkEmail = $(".tk_email").val();
	var tkTel = $(".tk_tel").val();
	if(tkTel) tkTel.replace(/[━.*‐.*―.*－.*\–.*ー.*\-]/gi,'');
	var tkContact = $(".tk_contact").val();

	// 入力内容チェック
	// 名前
	if (tkName == "") {
		$("#tk_name_error").html("Required field");
		$(".tk_name").addClass("inp_error");
		result = false;
	}else if (!tkName.match(/^[a-zA-Z\s]*$/)) {
		$("#tk_name_error").html("Field required in alphabets");
		$(".tk_name").addClass("inp_error");
		result = false;
	}

	// メールアドレス
	if (tkEmail == "") {
		$("#tk_email_error").html("Required field");
		$(".tk_email").addClass("inp_error");
		result = false;
	} else if (!tkEmail.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
		$('#tk_email_error').html(" Include &#34;@&#34; in your email address ");
		$(".tk_email").addClass("inp_error");
		result = false;
	}

	//電話番号
	
	if(tkTel == ""){
		$("#tk_tel_error").html(" Required field ");
		$(".tk_tel").addClass("inp_error");
	result = false;
	}else if((!tkTel.match(/^[0-9\-]+$/))){
		$('#tk_tel_error').html("Please enter a single-byte alphanumeric character");
		$(".tk_tel").addClass("inp_error");
		result = false;
	}
	
	// 問い合わせ
	if(tkContact == ""){
		$("#tk_contact_error").html("Required field");
		$(".tk_contact").addClass("inp_error");
	result = false;
	}

	return result;
}